module.exports = __webpack_public_path__ + "static/media/company3.1ae8e385.png";